import React from 'react';
const RolesConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/flag',
			component: React.lazy(() => import('./Flag'))
		}
	]
};

export default RolesConfig;
